import { object, string, ObjectSchema } from 'yup';

export interface SignUpFormProps {
  companyName?: string;
  email: string;
  firstName?: string;
  lastName?: string;
  password: string;
  passwordCompare: string;
  role: string;
}

export enum AccountType {
  Common = 'common',
  Company = 'company'
}

export const signupFields = [
  { label: 'label.email', name: 'email', type: 'email' },
  { label: 'label.password', name: 'password', type: 'password' },
  { label: 'label.confirm password', name: 'passwordCompare', type: 'password' }
];

export const signupInfoFields = [
  { label: 'label.first name', name: 'firstName', role: AccountType.Common, type: 'text' },
  { label: 'label.last name', name: 'lastName', role: AccountType.Common, type: 'text' },
  { label: 'label.company name', name: 'companyName', role: AccountType.Company, type: 'text' }
];

export const SignupSchema = object().shape({
  role: string().required('errors.account type is required'),
  companyName: string().when('role', (role: string, passSchema: ObjectSchema) =>
    role === AccountType.Common ? passSchema : passSchema.required('errors.company name is required')
  ),
  email: string()
    .email('errors.email is not valid')
    .required('errors.email is required'),
  firstName: string().when('role', (role: string, passSchema: ObjectSchema) =>
    role === AccountType.Company ? passSchema : passSchema.required('errors.first name is required')
  ),
  lastName: string().when('role', (role: string, passSchema: ObjectSchema) =>
    role === AccountType.Company ? passSchema : passSchema.required('errors.last name is required')
  ),
  password: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required'),
  passwordCompare: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required')
    .test(
      'password',
      'errors.password must be confirmed',
      /* eslint-disable func-names */ function(passwordCompare) {
        return passwordCompare === this.parent.password;
      }
    )
});
